<div class="current-holding">
	<p>{{ "web3_signup_current_holding" | translate }}</p>

	<ul class="asset-list">
		@for (data of availableAssets; track data.asset.getPid()) {
			@if ((data.balance | convert_tradable_to_fiat: data.asset.getId()) > 0) {
				<li>
					<div class="asset">
						<div class="icon">
							<img
								[src]="data.asset?.getLogo()"
								(error)="img.src = data.asset.getDefaultLogo()"
								alt="{{ 'logo_alt_text' | translate }}"
								#img />
						</div>
						<div class="name">{{ data.asset.getSymbol() }}</div>
						<div class="spacer"></div>
						<div class="balance">
							@if ((data.balance | convert_tradable_to_fiat: data.asset.getId()) < 0.01) {
								&lt;
							}

							{{
								data.balance
									| convert_tradable_to_fiat: data.asset.getId()
									| fiat_precision_symbol
										: {
												id: defaultFiat.getId(),
												currencies: [defaultFiat],
												symbol: true
										  }
							}}</div
						>
					</div>
				</li>
			}
		}
	</ul>
</div>
